export default "__VITE_ASSET__BVeGY7mI__"